import React from 'react';
import styled from 'styled-components';
import { useQuery } from '@apollo/client';
import { GET_ARTICLE } from '../graphql/queries';

interface Props extends React.HTMLProps<HTMLDivElement> {
	componentId: string;
	locale: string;
}

const RichText = styled.div`
	${({ theme }) => theme.richtext};
	text-align: center;
`;

const Container = styled.div`
	width: 600px;
	margin: 0 auto;
	padding-top: 104px;
`;

const Title = styled.h2`
	${({ theme }) => theme.typography.heading4};
	margin: 0 0 48px;
	color: inherit;
	text-transform: uppercase;
	text-align: center;
`;

export const Info = ({ componentId, locale, className }: Props) => {
	const { data, loading } = useQuery(GET_ARTICLE, { variables: { id: componentId, locale } });

	return loading
		? <div>loading</div>
		: <Container className={className}>
			<Title>{data.article.heading}</Title>
			<RichText dangerouslySetInnerHTML={{ __html: data.article.bodyHTML }} />
		</Container>
}